import { createAction, props } from '@ngrx/store';
import {
  BikeCenter,
  BikeFilters,
  BikeType,
  DriverHeight,
  RentalDuration,
} from '@shared-models';

const actionPrefix = '[BICYCLES]';

export const setBikeFiltersAction = createAction(
  `${actionPrefix} Set Filters`,
  props<{ filters: BikeFilters }>(),
);

export const setBikeFiltersBikeCenterAction = createAction(
  `${actionPrefix} Set bike center`,
  props<{ filters: BikeFilters }>(),
);

export const showFilteredResultsAction = createAction(
  `${actionPrefix} Show Filtered Results`,
  props<{ showResults: boolean }>(),
);

export const setRentalDurationsAction = createAction(
  `${actionPrefix} Set Rental Durations`,
  props<{ durations: RentalDuration[] }>(),
);

export const setDriverHeightsAction = createAction(
  `${actionPrefix} Set Driver Heights`,
  props<{ heights: DriverHeight[] }>(),
);

export const setHoursAction = createAction(
  `${actionPrefix} Set Hours`,
  props<{ hours: string[] }>(),
);

export const setBikeTypesAction = createAction(
  `${actionPrefix} Set Bike Types`,
  props<{ bikeTypes: BikeType[] }>(),
);

export const setBikeCentersAction = createAction(
  `${actionPrefix} Set Bike Centers`,
  props<{ bikeCenters: BikeCenter[] }>(),
);

export const setFilterDateErrorAction = createAction(
  `${actionPrefix} Set Filter Date Error`,
  props<{ showError: boolean }>(),
);

export const reserveBicycleAction = createAction(
  `${actionPrefix} Reserve Bicycle`,
  props<{ bicycle: string; index: number }>(),
);

export const addAdditionalGearAction = createAction(
  `${actionPrefix} Add Additional Gear`,
  props<{ gearId: string; control: 'add' | 'remove' | 'reset' }>(),
);

export const addNoteToCartAction = createAction(
  `${actionPrefix} Add Note to Cart`,
  props<{ note: string }>(),
);

export const setSearchTermAction = createAction(
  `${actionPrefix} Search`,
  props<{ term: string }>(),
);
